<template>
  <div>
    <Row :gutter="10" class="grid-list-row" type="flex">
      <Col :span="column.colSpan" class="pointer text-left" align="middle"
        @click.native="routeToIndentDetails"
        v-for="(column, index) in sectionHeader"
        :key="index">
          <div v-if="column.label==='category'">
            <span v-if="freightBillCategoryMap[freightBill[column.label]]">
              <Tooltip class="item" effect="dark" placement="bottom"
                v-if="freightBillCategoryMap[freightBill[column.label]].hoverValue">
                <div slot="content" class="tooltipcontent">
                  {{freightBillCategoryMap[freightBill[column.label]].hoverValue}}
                </div>
                <span>{{freightBillCategoryMap[freightBill[column.label]].name}}</span>
              </Tooltip>
            </span>
          </div>
          <div v-else>
            <span v-if="freightBill[column.label]">
              {{freightBill[column.label]}}
            </span>
          </div>
      </Col>
    </Row>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import { mapGetters } from 'vuex';

export default {
  created() {
    this.freightBillCategoryMap = this.getFreightBillCategories();
  },
  props: {
    freightBill: {
      type: Object,
      required: true,
    },
    sectionHeader: {
      type: Array,
      required: true,
    },
    index: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      freightBillCategoryMap: {},
      errorMessage: [],
    };
  },
  computed: {
    ...mapGetters({
      currentClientConfig: 'app/currentClientConfig',
    }),
  },
  methods: {
    routeToIndentDetails() {
      this.$router.push({ name: 'FreightBillIndentDetails', query: { freightBillId: this.freightBill.id } });
    },
    getFreightBillCategories() {
      const Categories = this.currentClientConfig.freight_bill.categories;
      const FreightBillCategoryMap = {};
      Categories.forEach((element) => {
        let hoverValue;
        if (element.date_range.is_daily) {
          hoverValue = 'Daily Invoice generatable ';
        } else {
          hoverValue = `Freight Bill (${element.date_range.start_day} - ${element.date_range.end_day})`;
        }
        FreightBillCategoryMap[element.short_code] = {
          name: element.name.toUpperCase(),
          short_code: element.short_code,
          start: element.date_range.start_day,
          end: element.date_range.end_day,
          is_daily: element.date_range.is_daily,
          hoverValue,
        };
      });
      this.$store.commit('paymentsV2/setFreightBillCategories', FreightBillCategoryMap);
      return FreightBillCategoryMap;
    },
  },
};
</script>
